import React, { useEffect, useState } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import CngSection from 'src/components/cngcomponents/CngSection'
import HouseBillResponse from '../manifest/response/HouseBillResponse'
import CloseMessageResponse from '../manifest/response/CloseMessageResponse'
import D4NoticeResponse from '../manifest/response/D4NoticeResponse'

const { CngTabs } = components
const {
  filter: { EQUAL }
} = constants

function ResponseLog(props) {
  const { fetchRecords, securedSendRequest } = useServices()
  const { manifestId, ccn, previousCcn } = props
  
  return (
    <CngSection title='Response log'>
      <CngTabs
        headerColor='primary'
        tabs={[
          {
            tabName: 'House Bill',
            tabContent: <HouseBillResponse id={manifestId} ccn={ccn} />
          },
          {
            tabName: 'Close Message',
            tabContent: <CloseMessageResponse id={manifestId} />
          },
          {
            tabName: 'D4 Notice',
            tabContent: <D4NoticeResponse id={manifestId} ccn={ccn} />
          }
        ]}
      />
    </CngSection>
  )
}

export default ResponseLog
